import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";

const WaitingRoom = () => {
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    const token = localStorage.getItem('userToken');
    const socket = useRef(null);
    const [rerender, setRerender] = useState(0);
    const [user, setUser] = useState(0);
    const gameId = localStorage.getItem('gameId');
    const gameName = localStorage.getItem('gameName');

    useEffect(() => {
        console.log('Initializing WebSocket connection...');

        loadUsers();

        // Initialize WebSocket connection with detailed logging
        socket.current = io(process.env.REACT_APP_SOCKET_URL, {
            path: "/socket.io", // Ensure this matches the path in your server config
            transports: ["websocket"], // Use WebSocket transport explicitly
        });

        // Log WebSocket connection status
        socket.current.on('connect', () => {
            console.log('WebSocket connected with ID:', socket.current.id);
        });

        // Handle new user joining
        const updateUser = `new-user-${gameId}`;
        console.log('Listening for new users:', updateUser);
        socket.current.on(updateUser, (newUser) => {
            console.log("New user received:", newUser);

            setUsers((prevUsers) => {
                const updatedUsers = [...prevUsers, newUser];
                console.log("Updated users list:", updatedUsers);
                setRerender((prev) => prev + 1); // Trigger re-render
                return updatedUsers;
            });
        });

        // Handle game start event
        const startGame = `start-game-${gameId}`;
        console.log('Listening for game start event:', startGame);
        socket.current.on(startGame, () => {
            console.log('Game is starting...');
            navigate("/Game");
        });

        // Log connection error
        socket.current.on("connect_error", (err) => {
            console.error("WebSocket connection failed:", err);
        });

        // Log WebSocket error
        socket.current.on("error", (error) => {
            console.error("WebSocket error:", error);
        });

        // Cleanup on component unmount
        return () => {
            if (socket.current) {
                console.log('Disconnecting WebSocket...');
                socket.current.disconnect();
            }
        };
    }, []);

    const loadUsers = async () => {
        console.log("getting users in waiting room!" + gameId, token);
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get-game-users`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token: token, game_id: gameId }),

            });

            const result = await response.json();
            console.log("result" + result);
            if (result.players && result.user) {
                console.log("Response from API:", result);
                setUsers(result.players)
                setUser(result.user)
            }

        } catch (error) {
            console.error("Error calling API:", error);
        }
    };

    const handleSubmit = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/start_game`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ game_id: gameId })
            });

            const result = await response.json();
            if (result.gameToken) {
                console.log("Response from API:", result);
                localStorage.setItem('gameToken', result.gameToken);
                navigate("/Game");
            }

        } catch (error) {
            console.error("Error calling API:", error);
        }
    };


    return (
        <div className="card py-6 h-screen">
            <div className="sub-card mb-10">
                <p className="text-2xl font-bold ytext">SOBA: {gameName}</p>

            </div>
            <div className="sub-card ">
                <p className="text-2xl mb-10 ytext">Igralci:</p>
                <ul className="mb-10">
                    {users.map((user, index) => (
                        <li key={index} className="wtext text-lg text-center">
                            🐒 {user.player}
                        </li>
                    ))}
                </ul>
                {user.admin ?
                    <button onClick={() => handleSubmit()} className="w-full py-3 rounded-lg shadow-md transition duration-300 mt-10"
                    >Začni igro</button>
                    : <p className="cursor typewriter-animation text-amber-300">Čakanje banke na začetek igre...</p>
                }

            </div>


        </div>
    )
};

export default WaitingRoom;
